import { render, staticRenderFns } from "./KomchatAi.vue?vue&type=template&id=412d84b7&"
import script from "./KomchatAi.vue?vue&type=script&lang=js&"
export * from "./KomchatAi.vue?vue&type=script&lang=js&"
import style0 from "./KomchatAi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports